if ($('#customer_table').length) {

    let url = window.location.origin + '/clientes/get';

    setTimeout(function () {
        users_table();
    }, 500);

    function users_table() {
        $('#customer_table').dataTable({
            "processing": true,
            "serverSide": true,
            "ajax": url,
            "columns": [
                {data: 'name'},
                {data: 'email'},
                {data: 'phone'},
                {data: 'sap_code'},
                {data: 'status'},
            ],
            "order": [[4, 'asc']],
            "columnDefs": [
                {
                    "targets": 4,
                    "render": function (data, type, row, meta) {
                        if (row.status  === Status.ACTIVO) {
                            return "<span class='badge badge-success'><big>Activo</big></span>";
                        } else {
                            return "<span class='badge badge-danger'><big>Suspendido</big></span>";
                        }
                    }
                },
                {
                    "targets": 5,
                    "render": function (data, type, row, meta) {

                        //if (row.id === 1) return "No Aplica";

                        if (row.status === 'A') {
                            /*
                            return "<button type='button' class='btn btn-primary btn-sm edit-customers' data-customer='" + row + "'><i class='fas fa-pencil-alt'></i></button> "
                                + "<button type='button' class='btn btn-primary btn-sm address-customers' data-customer-id='" + row.id + "'><i class='fa fa-address-card '></i></button> "
                                + "<button type='button' class='btn btn-primary btn-sm maps-customers' data-customer-id='" + row.id + "'><i class='fa fa-eye '></i></button> "
                                + "<button type='button' class='btn btn-danger btn-sm remove-customers' data-customer='" + row + "'><i class='fas fa-trash'></i></button> ";
                             */
                            return "<button type='button' class='btn btn-primary btn-sm edit-customers' data-customer='" + row + "' data-bs-toggle='tooltip' title='Editar Cliente'><i class='fas fa-pencil-alt'></i></button> "
                                + "<button type='button' class='btn btn-primary btn-sm address-customers' data-customer-id='" + row.id + "' data-bs-toggle='tooltip' title='Ver Dirección'><i class='fa fa-address-card'></i></button> "
                                + "<button type='button' class='btn btn-primary btn-sm maps-customers' data-customer-id='" + row.id + "' data-bs-toggle='tooltip' title='Ver Mapa'><i class='fa fa-eye'></i></button> "
                                + "<button type='button' class='btn btn-danger btn-sm remove-customers' data-customer='" + row + "' data-bs-toggle='tooltip' title='Suspender Cliente'><i class='fas fa-trash'></i></button>";

                        } else {
                            return "<button type='button' class='btn btn-success btn-sm activate-customers' data-id='" + row.id + "' data-bs-toggle='tooltip' title='Reactivar Cliente'><i class='fa fa-check'></i></button> ";
                        }
                    }
                }],
            "language": {
                "url": window.location.origin + "/json/Spanish.json"
            },
        });

        $('#customer_table').on('draw.dt', function () {
            $('[data-bs-toggle="tooltip"]').tooltip();
        });

        $('#customer_table tbody').on('click', '.edit-customers', function (e) {
            e.preventDefault();
            let table = $("#customer_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();

            $.ajax({
                url: window.location.origin + '/clientes/' + rowData.id + '/edit',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal').innerHTML = response;
                    $('.chosen-select').chosen({width: '100%'});
                    $('#modal-customers').modal("show");

                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        });

        $('#customer_table tbody').on('click', '.maps-customers', function (e) {
            e.preventDefault();
            let table = $("#customer_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();

            $.ajax({
                url: window.location.origin + '/mostrar-mapa/' + rowData.id,
                type: 'GET',
            })
                .done(function (response) {

                    if (Number(response) === 0) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Advertencia',
                            text: 'Primero debe agregar una dirección para visualizar el mapa.'
                        });
                        return false
                    }

                    document.getElementById('div_modal').innerHTML = response;
                    $('#modal_add_address').modal("show");
                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        });

        $('#customer_table tbody').on('click', '.address-customers', function (e) {
            e.preventDefault();
            let table = $("#customer_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();
            loadCustomerAddress(rowData.id);
        });

        $('#customer_table tbody').on('click', '.remove-customers', function (e) {
            e.preventDefault();
            let table = $("#customer_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();
            Swal
                .fire({
                    title: "Suspender al cliente " + rowData.name,
                    text: "¿Suspender?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Sí, suspender",
                    cancelButtonText: "Cancelar",
                })
                .then(resultado => {
                    if (resultado.value) {
                        let url = window.location.origin + '/clientes/' + rowData.id;
                        $.ajax({
                            url: url,
                            type: 'DELETE',
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        })
                            .done(function (response) {
                                Swal.fire('Suspendido', 'Se ha suspendido al cliente.', 'success')
                                    .then(() => {
                                        let url = window.location.origin + '/clientes/get';
                                        $('#customer_table').DataTable().ajax.url(url).load();
                                    });
                            })
                            .fail(function (jqXHR, textStatus) {
                                console.log(jqXHR);
                                alert("Disculpe, existió un problema");
                            });
                    }
                });
        });

        $('#customer_table tbody').on('click', '.activate-customers', function (e) {
            e.preventDefault();
            let table = $("#customer_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();

            Swal
                .fire({
                    title: "Reactivar al cliente " + rowData.name,
                    text: "¿Activar?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Sí, activarlo",
                    cancelButtonText: "Cancelar",
                })
                .then(resultado => {
                    if (resultado.value) {
                        $.ajax({
                            url: window.location.origin + '/customers/reactivate',
                            type: 'POST',
                            data: {
                                id: rowData.id
                            },
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        })
                            .done(function (response) {
                                Swal.fire('Activado', 'Se ha reactivado el usuario.', 'success')
                                    .then(() => {
                                        let url = window.location.origin + '/clientes/get';
                                        $('#customer_table').DataTable().ajax.url(url).load();
                                    });
                            })
                            .fail(function (jqXHR, textStatus) {
                                console.log(jqXHR);
                                alert("Disculpe, existió un problema");
                            });
                    }
                });
        });
    }

    function loadCustomerAddress(id) {
        $.ajax({
            url: window.location.origin + '/customers/address/' + id + '/get',
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_modal').innerHTML = response;
                $('#modal_add_address').modal("show");
            })
            .fail(function () {
                alert("Disculpe, existió un problema");
            });
    }


    $(".add_customers").on('click', function () {

        $.ajax({
            url: window.location.origin + '/clientes/create',
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_modal').innerHTML = response;
                $('.chosen-select').chosen({width: '100%'});
                $('#modal-customers').modal("show");

            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });

    })

    $(document).on('click', '#send_customers', function (event) {
        event.preventDefault();

        let url = window.location.origin + '/clientes';
        let formData = new FormData();


        formData.append('name', $("#name").val());
        formData.append('email', $("#email").val());
        formData.append('phone', $("#phone").val());
        formData.append('sap_code', $("#sap_code").val());
        formData.append('user_id', $("#user_id").val());
        formData.append('route_id', $("#route_id").val());

        document.getElementById('div_message').innerHTML = "";
        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                if (response.success) {
                    Swal.fire('Agregado', response.message, 'success')
                        .then(() => {
                            $('#modal-customers').modal("hide");
                            let url = window.location.origin + '/clientes/get';
                            $('#customer_table').DataTable().ajax.url(url).load();

                            if (response.customer_id !== 0) {
                                setTimeout(function () {
                                    loadCustomerAddress(response.customer_id);
                                }, 500);
                            }

                        });
                } else {
                    Swal.fire('Error', response.message, 'error');
                }
            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });

    $(document).on('click', '#sent_customers_update', function (event) {

        event.preventDefault();
        let id = $("#id").val();
        let url = window.location.origin + '/clientes/' + id;
        //alert(url)
        let formData = new FormData();
        formData.append('id', id);
        formData.append('name', $("#name").val());
        formData.append('email', $("#email").val());
        formData.append('phone', $("#phone").val());
        formData.append('sap_code', $("#sap_code").val());
        formData.append('user_id', $("#user_id").val());
        formData.append('route_id', $("#route_id").val());
        formData.append('_method', 'PUT'); //requerido para enviar el archivo se tiene que usar post en ajax

        document.getElementById('div_message').innerHTML = "";
        $.ajax({
            data: formData,
            url: url,
            //type: 'PUT',
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {

                if (typeof response['status'] !== 'undefined') {
                    Swal.fire('Advertencia', response['message'], 'info')
                        .then(() => {
                            location.reload();
                        });
                } else {
                    Swal.fire('Actualizado', 'Se actualizo el cliente correctamente', 'success')
                        .then(() => {
                            $('#modal-customers').modal("hide");
                            let url = window.location.origin + '/clientes/get';
                            $('#customer_table').DataTable().ajax.url(url).load();
                        });
                }

            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });


    $(document).on('keyup', '.change_address', function (e) {
        let data = new FormData();
        data.append('zipCode', $(".change_address").val());
        getInfoByZipCode(data);
    });

    $(document).on('keyup', '.item-codigo_postal', function (e) {
        let data = new FormData();
        data.append('zipCode', $(".item-codigo_postal").val());
        getInfoByZipCodeEdit(data)
    })

    function getInfoByZipCode(datos) {
        $.ajax({
            url: "/get-info-by-zip-code",
            type: "POST",
            data: datos,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success === "success") {
                    clearSpan()
                    listZipCodes(data.zipCodes);
                } else {
                    $("#list-zipCode").hide();
                    $("#item-codigo-postal-error").html(data.msg).css('color', 'red')
                    clearInputs();
                }
            },
            error: function (errors) {
                var indices = errors.responseJSON;
                $.each(indices, function (index, value) {
                    console.log(index, value)
                });
            }
        });
    }

    function getInfoByZipCodeEdit(datos) {
        $.ajax({
            url: "/get-info-by-zip-code",
            type: "POST",
            data: datos,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success == "success") {
                    clearSpan();
                    listZipCodes1(data.zipCodes);
                } else {
                    $(".item-codigo-postal-error").html(data.msg).css('color', 'red')
                    $("#list-zipCode1").hide();
                    $("#item-codigo-postal-error").html(data.msg).css('color', 'red')
                }
            },
            error: function (errors) {
                var indices = errors.responseJSON;
                $.each(indices, function (index, value) {

                });
            }
        });
    }


    function clearSpan() {
        $("#item-nombre-error").html("");
        $("#item-telefono-error").html("");
        $("#item-codigo-postal-error").html("");
        $("#item-estado-error").html("");
        $("#item-ciudad-error").html("");
        $("#item-municipio-error").html("");
        $("#item-colonia-error").html("");
        $("#item-calle-error").html("");
        $("#item-num_exterior-error").html("");
        $("#item-num_interior-error").html("");
        $("#item-direccion_predeterminada-error").html("");
        $("#item-referencia-error").html("");
        $(".item-error-phone").html("");
    }

    function clearInputs() {
        $("#estado").val("");
        $("#ciudad").val("");
        $("#municipio").val("");
        $("#colonia").val("");
    }


    function listZipCodes(data, ele) {
        $("#list-zipCode").show();
        $("#list-zipCode").html("");
        let item;
        $.each(data, function (key, value) {
            item = '<a href="#" data-id="' + data[key].id + '" data-ciudad="' + data[key].ciudad + '"  ' +
                'data-estado="' + data[key].estado + '" data-municipio="' + data[key].municipio + '" ' +
                'data-tipo_asenta="' + data[key].d_tipo_asenta + '" data-colonia="' + data[key].colonia + '" ' +
                'data-municipo="' + data[key].municipo + '" ' +
                'class="list-group-item list-group-item-action select-item" >' + data[key].d_tipo_asenta + " - " + data[key].colonia + " - " + data[key].municipio + ' </a>';
            $("#list-zipCode").append(item);
        });
    }

    function listZipCodes1(data, ele) {
        $("#list-zipCode1").show();
        $("#list-zipCode1").html("");
        let item;
        $.each(data, function (key, value) {
            item = '<a href="#" data-zip_code_id="' + data[key].id + '" data-ciudad="' + data[key].ciudad + '"  ' +
                'data-estado="' + data[key].estado + '" data-municipio="' + data[key].municipio + '" ' +
                'data-tipo_asenta="' + data[key].d_tipo_asenta + '" data-colonia="' + data[key].colonia + '" ' +
                'data-municipo="' + data[key].municipo + '" ' +
                'class="list-group-item list-group-item-action select-item1" >' + data[key].d_tipo_asenta + " - " + data[key].colonia + " - " + data[key].municipio + ' </a>';
            $("#list-zipCode1").append(item);
        });
    }

    $(document).on('click', ".select-item", function (e) {
        e.preventDefault();
        var colonia = $(this).attr("data-tipo_asenta") + " " + $(this).attr("data-colonia");
        $("#id").val($(this).attr("data-id"));
        $("#estado").val($(this).attr("data-estado"));
        $("#ciudad").val($(this).attr("data-ciudad"));
        $("#municipio").val($(this).attr("data-municipio"));
        $("#colonia").val(colonia);
        $("#list-zipCode").hide();
    });

    $(document).on('click', '.select-item1', function (e) {
        e.preventDefault();
        var colonia = $(this).attr("data-tipo_asenta") + " " + $(this).attr("data-colonia");
        $(".item-zip_code_id").val($(this).attr("data-zip_code_id"));
        $(".item-estado").val($(this).attr("data-estado"));
        $(".item-ciudad").val($(this).attr("data-ciudad"));
        $(".item-municipio").val($(this).attr("data-municipio"));
        $(".item-colonia").val(colonia);
        $("#list-zipCode1").hide();
    });


    $(document).on('submit', "#form-agregar-direccion", function (e) {
        e.preventDefault();
        const data = $(this).serialize();

        $.ajax({
            method: "POST",
            url: window.location.origin + '/add-address',
            data: data,
            success: function (data) {

                const isSuccess = data.status === "success";

                if (isSuccess) $('#modal_add_address').modal('hide');

                Swal.fire({
                    title: data.title || (isSuccess ? '' : 'Ocurrió un problema'),
                    text: data.message || (isSuccess ? '' : 'No se pudo completar la acción solicitada.'),
                    icon: isSuccess ? 'success' : 'error'
                });

                if (!isSuccess) console.log(data);

            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });
    });

    $(document).on('submit', "#form-edit-direccion", function (e) {
        e.preventDefault();
        const data = $(this).serialize();

        $.ajax({
            method: "POST",
            url: '/update-addresses',
            data: data,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                const isSuccess = data.status === "success";

                if (isSuccess) $('#modal_edit_addresses').modal('hide');

                Swal.fire({
                    title: data.title || (isSuccess ? '' : 'Ocurrió un problema'),
                    text: data.message || (isSuccess ? '' : 'No se pudo completar la acción solicitada.'),
                    icon: isSuccess ? 'success' : 'error'
                });

                if (!isSuccess) console.log(data);

            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });

    })

    $(document).on('click', '.show-edit-directions', function (e) {
        e.preventDefault();
        let data = new FormData();
        let slug = $(this).data('data');
        $("#modal_add_address").modal("hide");
        data.append('value', slug)
        editAddresses(data);
    });

    function editAddresses(value) {
        $.ajax({
            method: "POST",
            url: '/edit-address',
            data: value,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (view) {
                setTimeout(function () {
                    document.getElementById('div_modal').innerHTML = view;
                    setTimeout(function () {
                        $(".modal_add_address").modal("show");
                    }, 400);
                }, 300);
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });
    }


    $(document).on('click', '.delete-attribute-link', function (e) {
        let reference = $(this).data('reference');
        let data = new FormData();
        data.append('id', reference);
        Swal.fire({
            title: '¿Estas seguro?',
            text: "La dirección seleccionada sera eliminada",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#023B59',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteItem(data, reference);
            }
        })
    });


    function deleteItem(data, position) {
        $.ajax({
            method: "POST",
            url: '/delete-addresses',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                if (data.success === "success") {
                    Swal.fire({
                        title: 'Eliminado',
                        text: data.msg,
                        icon: 'success',
                    }).then((result) => {
                        setTimeout(function () {
                            $(".direcciones_contenedor-" + position).remove();
                        }, 300);
                    })
                } else {
                    //alertError(data.msg)
                    Swal.fire('Error', data.msg, 'error');
                }
            },
            error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-" + index + "-error").html(value).css('color', 'red');
                });
            }
        });
    }


    $(document).on('click', '#open_modal_add_address_from_show_directions', function (e) {
        e.preventDefault();
        $('#modal_add_address').modal("hide");
        let customerId = $(this).data('id');
        let forceAdd = 1;

        setTimeout(function () {
            $.ajax({
                url: window.location.origin + '/customers/address/' + customerId + '/get/' + forceAdd,
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal').innerHTML = response;
                    //$('.chosen-select').chosen({width: '100%'});
                    $('#modal_add_address').modal("show");

                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });

        }, 300)
    });


}
